import {Action, Selector, State, StateContext, Store} from "@ngxs/store";
import {OperationsSymbolStateInterface} from "../models/operations-symbol-state.interface";
import {Injectable} from "@angular/core";
import {RequestService} from "../services/request.service";
import {AppHelper} from "../helpers/app.helper";
import {InstrumentoService} from "../services/instrumento.service";
import {OperationsSymbolAction} from "../actions/operations-symbol-action";
import { PaginationAction } from "../actions/pagination-action";
import FetchOperationsSymbol = OperationsSymbolAction.FetchOperationsSymbol;
import FetchData = PaginationAction.FetchData;
import { CarteraService } from '../services/cartera.service';

@State<OperationsSymbolStateInterface>({
  name: 'OPSymbolData',
  defaults: {
    operationsSymbolData: [],
  }
})
@Injectable()
export class OperationsSymbolState {

  constructor(private requestService: RequestService,
              private store: Store,
              private instrumentoService: InstrumentoService,
              private carteraService: CarteraService) {
  }

  @Selector()
  static operationsSymbolData(state: OperationsSymbolStateInterface) {
    return state.operationsSymbolData;
  }

   //Set simbolos ha actualizar
   @Action(FetchOperationsSymbol)
   async fetchOperationsSymbol({getState, setState}: StateContext<OperationsSymbolStateInterface>, action: FetchOperationsSymbol){
 
     let content: any = { };
 
     //let data: any = { };

     console.log('Entrando fetchOperationsSymbol ');

     const pagination = this.store.selectSnapshot(state => state.paginationData).pagination;
     
     try {
 
       content = await this.carteraService.obtenerSimbolos(action.id, action.hideLoading);
 
     } catch (e) {
 
       AppHelper.DevPrint(e);
     }
 
     //data = {...content};
 
     //data.data = [];
 
    // setState({ ...getState(), ... { operacionesSimbolo: content.data } } );
     setState({ ...getState(), ... { operationsSymbolData: content.data } } );
     console.log('Datos escrito');
 
   // this.store.dispatch( new FetchData(content.data));
 
  }

  

}
